import React, { Component } from 'react';
import {
    Link
} from 'react-router-dom';
import $ from 'jquery'
import seal1 from "../../images/VeriSign_transparent.png";
import seal2 from '../../images/visa_transparent.png'

class SubFooter extends Component {
    render() {
        return (
            <div >
                <div className="sub-footer">
                    <Link to="/PDS">PDS </Link>
                    <Link to="/Notices">Notices </Link>
                    {/* <Link to="/terms-&-conditions">Terms & Conditions</Link> */}
                    <Link to="/privacy-policy">Privacy Policy</Link>
                    <Link to="/security-awareness">Security Awareness</Link>
                    <div>
                        <img src={seal1} alt="" />
                        <img src={seal2} alt="" />
                    </div>
                </div>

            </div>
        );
    }
}

export default SubFooter;


// WEBPACK FOOTER //
// ./src/components/subfooter/subfooter.jsx